var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.plaid && _vm.plaid.key)?_c('plaid-link',_vm._b({attrs:{"env":_vm.plaid.env,"plaid-url":"//cdn.plaid.com/link/v2/stable/link-initialize.js","token":_vm.plaid.linkToken,"client-name":"Kasasa","product":"auth"},scopedSlots:_vm._u([{key:"button",fn:function(prop){return [_vm._t("default",null,{"context":prop})]}}],null,true)},'plaid-link',{
		onSuccess: _vm.emitSuccess,
		onEvent: _vm.emitEvent
	},false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }